export const getErrorMessage = (error?: any) => {
  return error
    ? (typeof error === 'object' && (error as Error).message) ||
        (typeof error === 'string' && error) ||
        'Unknown Error'
    : '';
};
